import React, { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import { useTheme } from "../../context/ThemeContext";
import { FaCog, FaTimes } from "react-icons/fa";

const ThemeSettings = () => {
  const [show, setShow] = useState(false);

  const {
    changePrimaryColor,
    changeNavigationHader,
    chnageHaderColor,
    chnageSidebarColor,
    changeBackground,
    background,
    colors,
    season, 
    changeSeason
  } = useTheme();

  /* 🛑 IMPORTANTE: CALIBRACIÓN DE COLORES
     Si haces clic en un color y el tema cambia a otro diferente,
     cambia el código HEX aquí abajo para que coincida.
  */
  const colorMap = {
    "color_1": "#fcfcfdff", // Azul Oscuro (Default Innap)
    "color_2": "#5E35B1", // Morado
    "color_3": "#1362FC", // Verde Azulado
    "color_4": "#E91E63", // Rosa Fuerte
    "color_5": "#FF5722", // Naranja Rojizo
    "color_6": "#FCB040", // Amarillo/Naranja
    "color_7": "#1eaaf1", // Celeste
    "color_8": "#3CB371", // Verde
    "color_9": "#20c997", // Turquesa
    "color_10": "#0dcaf0", // Cian
    "color_11": "#000000", // Negro
    "color_12": "#795548", // Café
    "color_13": "#607d8b", // Gris
    "color_14": "#6f42c1", // Violeta (A veces este es el que falla, pruébalo)
    "color_15": "#198754", // Verde Oscuro
  };

  const renderColorOption = (colorName, onClickFunction) => (
    <div
      key={colorName}
      onClick={() => onClickFunction(colorName)}
      style={{
        width: "35px",
        height: "35px",
        margin: "5px",
        cursor: "pointer",
        borderRadius: "50%",
        border: "2px solid #fff",
        // Si el color no está en el mapa, usa gris para que sepas que falta definirlo
        backgroundColor: colorMap[colorName] || "#ccc", 
        boxShadow: "0 3px 6px rgba(0,0,0,0.16)",
        transition: "transform 0.2s"
      }}
      onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.2)"}
      onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
      title={colorName} // Deja el mouse encima para ver qué número de color es
    />
  );

  return (
    <>
      <div
        onClick={() => setShow(true)}
        style={{
          position: "fixed",
          top: "50%",
          right: "0",
          zIndex: "999",
          backgroundColor: "#435BB7",
          color: "white",
          padding: "12px",
          borderTopLeftRadius: "10px",
          borderBottomLeftRadius: "10px",
          cursor: "pointer",
          boxShadow: "-4px 4px 10px rgba(0,0,0,0.2)"
        }}
      >
        <FaCog className="fa-spin" size={22} />
      </div>

      <div
        className={`dz-demo-panel ${show ? "show" : ""}`}
        style={{
          position: "fixed",
          top: 0,
          right: show ? 0 : "-350px",
          width: "350px",
          height: "100vh",
          backgroundColor: "white",
          zIndex: 1000,
          transition: "all 0.4s cubic-bezier(0.77, 0, 0.175, 1)",
          boxShadow: "-5px 0 20px rgba(0,0,0,0.15)",
          overflowY: "auto"
        }}
      >
        <div className="p-4 d-flex justify-content-between align-items-center border-bottom bg-light">
          <h5 className="mb-0 fw-bold text-primary">Configuración de Tema</h5>
          <FaTimes 
            style={{ cursor: "pointer", color: "#666" }} 
            size={20} 
            onClick={() => setShow(false)} 
          />
        </div>

        <div className="p-4">
          <Tab.Container defaultActiveKey="Theme">
            <Nav variant="pills" className="nav-fill mb-4 p-1 bg-light rounded">
              <Nav.Item>
                <Nav.Link eventKey="Theme" className="rounded py-2">Tema</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Header" className="rounded py-2">Cabecera</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Content" className="rounded py-2">Lateral</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Season" className="rounded py-2">Eventos</Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Theme">
                <div className="mb-4">
                  <h6 className="mb-3 fw-bold">Modo de Color</h6>
                  <select 
                    className="form-control form-select" 
                    value={background.value}
                    onChange={(e) => changeBackground({ value: e.target.value, label: e.target.value })}
                  >
                    <option value="light">🌞 Claro (Light)</option>
                    <option value="dark">🌙 Oscuro (Dark)</option>
                  </select>
                </div>

                <div className="mb-4">
                  <h6 className="mb-3 fw-bold">Color Primario</h6>
                  <div className="d-flex flex-wrap">
                    {colors.map((color) => renderColorOption(color, changePrimaryColor))}
                  </div>
                </div>
              </Tab.Pane>

              <Tab.Pane eventKey="Header">
                <div className="mb-4">
                  <h6 className="mb-3 fw-bold">Color de Navegación</h6>
                  <div className="d-flex flex-wrap">
                    {colors.map((color) => renderColorOption(color, changeNavigationHader))}
                  </div>
                </div>

                <div className="mb-4">
                  <h6 className="mb-3 fw-bold">Fondo del Encabezado</h6>
                  <div className="d-flex flex-wrap">
                    {colors.map((color) => renderColorOption(color, chnageHaderColor))}
                  </div>
                </div>
              </Tab.Pane>

              <Tab.Pane eventKey="Content">
                <div className="mb-4">
                  <h6 className="mb-3 fw-bold">Color Barra Lateral</h6>
                  <div className="d-flex flex-wrap">
                    {colors.map((color) => renderColorOption(color, chnageSidebarColor))}
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="Season">
                <div className="mb-4">
                  <h6 className="mb-3 fw-bold">Modo Temporada</h6>
                  <div className="form-check mb-2">
                    <input 
                        className="form-check-input" type="radio" name="season" id="s_none"
                        checked={season === 'none'} 
                        onChange={() => changeSeason('none')} 
                    />
                    <label className="form-check-label" htmlFor="s_none">Ninguno (Normal)</label>
                  </div>
                  <div className="form-check mb-2">
                    <input 
                        className="form-check-input" type="radio" name="season" id="s_navidad"
                        checked={season === 'christmas'} 
                        onChange={() => changeSeason('christmas')} 
                    />
                    <label className="form-check-label" htmlFor="s_navidad">🎄 Navidad</label>
                  </div>
                  <div className="form-check mb-2">
                    <input 
                        className="form-check-input" type="radio" name="season" id="s_newyear"
                        checked={season === 'newyear'} 
                        onChange={() => changeSeason('newyear')} 
                    />
                    <label className="form-check-label" htmlFor="s_newyear">🎉 Año Nuevo</label>
                  </div>
                  <div className="form-check mb-2">
                    <input 
                        className="form-check-input" type="radio" name="season" id="s_cyber"
                        checked={season === 'cyber'} 
                        onChange={() => changeSeason('cyber')} 
                    />
                    <label className="form-check-label" htmlFor="s_cyber">🛒 Cyber Day</label>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
      
      {show && (
        <div 
            onClick={() => setShow(false)}
            style={{
                position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', 
                background: 'rgba(0,0,0,0.4)', zIndex: 999, backdropFilter: 'blur(2px)'
            }} 
        />
      )}
    </>
  );
};

export default ThemeSettings;